import styles from "./journalfilter.module.css";
import { useState } from "react";
import { ArrowRight, Calendar, Filter, Plus, Search } from "react-feather";
import dayjs from "dayjs";
import { DateRangePicker } from "rsuite";
import { Link } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import FilterAutocomplete from "../../../components/FilterAutocomplete";

const JournalFilter = ({ filterDateRange, filterData, propertyList, userList, setFilterData, setOpenAddForm, setFilterDateRange }) => {
    const [filterOpen, setFilterOpen] = useState(false);
    const { user, isAuthenticated } = useAuth0();

    const disableDate = (date) => {
        const d = dayjs(date);
        return d.isAfter(dayjs(), 'day');
    }

    const propertyOptions = (propertyList || []).map((i) => ({ value: i?.id, label: i?.name }));
    const userOptions = (userList || []).map((i) => ({ value: i?.id, label: i?.full_name }));

    return (<div className={`${styles.SearchFilterSec}`}>
        <div className={`${styles.SearchCon}`}>
            <div className={`${styles.SearchConSec}`}>
                <Search />
                <input type="text" placeholder="Search" value={filterData?.searchKey} onChange={(e) => setFilterData(prev => {
                    return { ...prev, searchKey: e.target.value }
                })} />
            </div>
        </div>

        <div className={`${styles.FilterSec}`}>
            <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
                <p className={`${styles.FilterTitle}`}>
                    Filters
                    <span onClick={(e) => setFilterOpen(false)}>
                        <ArrowRight />
                    </span>
                </p>
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width200} CusSelectFilter Filter Autocomplete`}>
                    <FilterAutocomplete
                        label="Property"
                        options={propertyOptions}
                        value={filterData?.property}
                        onChange={(value) => setFilterData(prev => ({ ...prev, property: value }))}
                    />
                </div>
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width200} CusSelectFilter Filter Autocomplete`}>
                    <FilterAutocomplete
                        label="User"
                        options={userOptions}
                        value={filterData?.user}
                        onChange={(value) => setFilterData(prev => ({ ...prev, user: value }))}
                    />
                </div>
                <div className={`${styles.FilterCard}`}>
                    <div className={`${styles.DashFilterSec} DashFilterSec Filter`}>
                        <DateRangePicker
                            format={"MM/dd/yy"}
                            placeholder={"Filter by date"}
                            placement={"bottomEnd"}
                            caretAs={Calendar}
                            showOneCalendar
                            value={filterDateRange}
                            onChange={(date) => {
                                setFilterDateRange(date);
                            }}
                        />
                    </div>
                </div>
            </div>
            <Link className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}>
                <Filter />
            </Link>
            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("journal:create") > -1 && <Link className={`${styles.AddNoteBu}`} onClick={(e) => setOpenAddForm(true)}>
                <Plus /> <span>Journal</span>
            </Link>}
        </div>
    </div>);
};

export default JournalFilter;